import React from "react";
import { TermController } from "../../core/config/controllers/TermController";
import { DateHelper } from "../../core/config/helpers/DateHelper";
import GoogleMapsRoute from "../administrator/user/components/GoogleMapRoutes";
import { VehicleController } from "../../core/config/controllers/VehicleController";
import { DeviceController } from "../../core/config/controllers/DeviceController";

export default function Shared() {
    const [vehicle, setVehicle] = React.useState([]);
    const [tracker, setTracker] = React.useState([]);
    const [positions, setPositions] = React.useState([]);
    const [data, setData] = React.useState({
        lat: -23.57,
        lng: -46.68,
    });

    React.useEffect(() => {
        // loadConfiguration();
        loadVehicle();
    }, []);

    React.useEffect(() => {
        loadPositions();
    }, [tracker]);

    function loadVehicle() {
        let vehicleId = null;
        const hash = window.location.hash;
        if (hash.includes('?')) {
            const queryString = hash.substring(hash.indexOf('?') + 1);
            const params = new URLSearchParams(queryString);
            vehicleId = params.get('vehicleId');
        }
        if (vehicleId) {

            VehicleController.Get(vehicleId, (res) => {
                if (res) {
                    console.log("vehicle data loaded:", res);
                    setVehicle(res);
                    loadTrackerData(vehicleId);
                } else {
                    console.error("Veículo não encontrado.");
                }
            });
        }
    }

    function loadTrackerData(vehicleId) {
        console.log("Tracker data loaded:", vehicleId);
        if (!vehicleId) return;
        DeviceController.ListByVehicle(vehicleId, (res) => {
            console.log("Tracker data loaded:", res);
            if (res && res.length > 0) {
                setTracker(res[0]);
                // loadPositions();
            } else {
                console.error("Nenhum rastreador encontrado para este veículo.");
            }
        });
    }

    function loadConfiguration() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setData({ lat: position.coords.latitude, lng: position.coords.longitude });
                },
                (error) => {
                    console.error("Erro ao obter localização:", error);
                }
            );
        } else {
            console.error("Geolocalização não suportada pelo navegador.");
        }
    }


    function loadPositions() {
        if (tracker && !tracker.id) return;

        const today = new Date();
        const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
        const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();
        // Função para buscar posições
        const fetchPositions = () => {
            const start = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
                    const end = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();
                    DeviceController.ListDateLocations(tracker.id, start, end, res => {
                            let result = res.data.result ?? [];
                            console.log("result", res);
                            const myPositions = result.filter(x => x.lat_value !== undefined && x.lat_value !== 0 && x.dt_value >= start && x.dt_value <= end) || [];
            
                            myPositions.sort((a, b) => a.dt_value - b.dt_value);
            
                            console.log("result", myPositions);
                            let distance = 0;
                            for (let i = 1; i < myPositions.length; i++) {
                                const prev = myPositions[i - 1];
                                const curr = myPositions[i];
                                const toRad = deg => deg * Math.PI / 180;
                                const R = 6371; // Earth radius in km
                                const dLat = toRad(curr.lat_value - prev.lat_value);
                                const dLng = toRad(curr.lng_value - prev.lng_value);
                                const lat1 = toRad(prev.lat_value);
                                const lat2 = toRad(curr.lat_value);
            
                                const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                                    Math.sin(dLng / 2) * Math.sin(dLng / 2) * Math.cos(lat1) * Math.cos(lat2);
                                const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
                                distance += R * c;
                            }
            
                            const maxSpeed = myPositions.reduce((max, pos) => pos.spd_value > max ? pos.spd_value : max, 0);
            
                            setData({
                                ...data,
                                distance: distance.toFixed(2),
                                maxSpeed: maxSpeed,
                                ...myPositions[0]
                            });
            
                            console.log("result", myPositions);
                            setPositions(myPositions);
                    })
        };

        // Chama imediatamente
        fetchPositions();

        // Atualiza a cada 2 minutos
        const intervalId = setInterval(fetchPositions, 2 * 60 * 1000);

        // Limpa o intervalo ao desmontar ou atualizar dependências
        return () => clearInterval(intervalId);
    }

    return (
        <div className="content">
            <h1 className="content-heading">Localização</h1>
            <GoogleMapsRoute
                defaultZoom={11}
                locations={positions}
                defaultCenter={{
                    lat: -23.57,
                    lng: -46.68,
                }}
                center={data}
                bootstrapURLKeys={{
                    key: "AIzaSyDN3UVIMYb0l_DCSkM6DwSnD6Ow3prkWZI",
                    libraries: ["drawing"],
                }}
                // Adiciona uma key para forçar o remount quando data muda
                key={`${data.lat},${data.lng}`}
            >
            </GoogleMapsRoute>
            <div className="block-content">

                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ fontWeight: 600, fontSize: 22, color: '#232323' }}>
                            {vehicle.manufacturer || 'Fabricante'} - {vehicle.model || 'Modelo'}
                        </div>
                        <div style={{ fontWeight: 600, fontSize: 18, color: '#232323' }}>
                            <i className="far fa-registered" /> Placa: {vehicle.plate || 'Placa'}
                        </div>
                        <div style={{ fontWeight: 600, fontSize: 18, color: '#232323' }}>
                            <i className="fa fa-tint" /> Cor: {vehicle.color_name || 'Cor'}
                        </div>
                    </div>
                    <img
                        src={'assets/media/carro.png'}
                        alt="Carro"
                        style={{ width: 140, height: 60, objectFit: 'contain' }}
                    />
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                    <span style={{ display: 'flex', alignItems: 'center', marginRight: 16, color: '#888', fontWeight: 500 }}>
                        <span style={{ marginRight: 6 }}>
                            <i className="si si-map" />
                        </span>
                        {data.distance || '0.00'} km
                    </span>
                    <span style={{ display: 'flex', alignItems: 'center', color: '#888', fontWeight: 500 }}>
                        <span style={{ marginRight: 6 }}>
                            <i className="si si-speedometer" />
                        </span>
                        {data.maxSpeed || '0'} km/h
                    </span>
                </div>

                <div className="content-heading" style={{ marginTop: 16 }}>
                    Rastreador
                </div>
                {tracker && tracker.id ? (
                    <table className="table table-striped table-vcenter">
                        <tbody>
                            <tr>
                                <td>Modelo</td>
                                <td>{tracker && tracker.name}</td>
                            </tr>
                        </tbody>
                    </table>
                ) :
                    <div className="alert alert-warning">
                        Nenhum rastreador vinculado a este veículo.
                    </div>
                }
            </div>
        </div>
    )
}